// // FixedPromotionBilling.jsx
// import React, { useState, useEffect } from "react";
// import {
//     FaEdit, FaSave, FaSpinner, FaCheckCircle, FaTag, FaMoneyBillWave,
//     FaClock, FaUser, FaMobileAlt, FaPlus, FaTrash, FaEye, FaTimes,
//     FaImage, FaVideo, FaCalendarAlt, FaDollarSign, FaCog
// } from "react-icons/fa";
// import { motion, AnimatePresence } from "framer-motion";

// // ─── Fixed Promotion Billing Component ──────────────────────────
// const FixedPromotionBilling = () => {
//     const [promotions, setPromotions] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [showModal, setShowModal] = useState(false);
//     const [editingPromotion, setEditingPromotion] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [hoveredRow, setHoveredRow] = useState(null);

//     // ─── Form State ──────────────────────────────────────────────
//     const [formData, setFormData] = useState({
//         category: '',
//         mediaType: 'both',
//         duration: '1_month',
//         price: '',
//         resolution: '',
//         description: '',
//         status: 'active',
//         noOfLoops: '200',
//         secondsPerAdd: '10'
//     });

//     // Add these with your other options arrays
//     const loopOptions = [
//         { value: '100', label: '100 Loops' },
//         { value: '200', label: '200 Loops' },
//         { value: '300', label: '300 Loops' },
//         { value: '500', label: '500 Loops' }
//     ];

//     const secondsOptions = [
//         { value: '5', label: '5 Seconds' },
//         { value: '10', label: '10 Seconds' },
//         { value: '15', label: '15 Seconds' },
//         { value: '20', label: '20 Seconds' },
//         { value: '30', label: '30 Seconds' }
//     ];

//     // ─── Options ──────────────────────────────────────────────────
//     const categoryOptions = [
//         { value: 'popup', label: 'Popup Advertisement', icon: '📱' },
//         { value: 'banner', label: 'Homepage Banner', icon: '🖼️' },
//         { value: 'deals', label: 'Featured Deals', icon: '🏷️' },
//         { value: 'checkout', label: 'Checkout Page Promotion', icon: '🛒' }
//     ];

//     const mediaTypeOptions = [
//         { value: 'image', label: 'Image Only' },
//         { value: 'video', label: 'Video Only' },
//         { value: 'both', label: 'Both Image & Video' }
//     ];

//     const durationOptions = [
//         { value: '1_day', label: '1 Day' },
//         { value: '1_week', label: '1 Week' },
//         { value: '2_weeks', label: '2 Weeks' },
//         { value: '1_month', label: '1 Month' },
//         { value: '3_months', label: '3 Months' },
//         { value: '6_months', label: '6 Months' }
//     ];

//     const resolutionOptions = [
//         { value: '1080x1080', label: '1080 × 1080 px' },
//         { value: '1920x600', label: '1920 × 600 px' },
//         { value: '1080x1920', label: '1080 × 1920 px' },
//         { value: '1920x1080', label: '1920 × 1080 px' }
//     ];

//     // ─── Fetch Data ──────────────────────────────────────────────
//     useEffect(() => {
//         fetchPromotions();
//     }, []);

//     const fetchPromotions = async () => {
//         try {
//             setLoading(true);
//             // Simulate API call - replace with actual API
//             // const response = await getFixedPromotionsAPI();
//             // setPromotions(response.data || []);

//             // Sample data for demo
//             setTimeout(() => {
//                 setPromotions([
//                     {
//                         id: 1,
//                         category: 'popup',
//                         mediaType: 'both',
//                         duration: '1_month',
//                         price: 999,
//                         resolution: '1080x1080',
//                         description: 'Popup Advertisement - Image & Video Support',
//                         status: 'active',
//                         createdAt: '2026-07-01'
//                     },
//                     {
//                         id: 2,
//                         category: 'banner',
//                         mediaType: 'image',
//                         duration: '1_month',
//                         price: 1499,
//                         resolution: '1920x600',
//                         description: 'Homepage Banner - Image Support',
//                         status: 'active',
//                         createdAt: '2026-07-05'
//                     },
//                     {
//                         id: 3,
//                         category: 'deals',
//                         mediaType: 'video',
//                         duration: '1_month',
//                         price: 1299,
//                         resolution: '1080x1080',
//                         description: 'Featured Deals - Video Support',
//                         status: 'inactive',
//                         createdAt: '2026-07-10'
//                     }
//                 ]);
//                 setLoading(false);
//             }, 500);
//         } catch (err) {
//             console.error("❌ Error fetching promotions:", err);
//             setLoading(false);
//         }
//     };

//     // ─── Form Handlers ────────────────────────────────────────────
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const resetForm = () => {
//         setFormData({
//             category: '',
//             mediaType: 'both',
//             duration: '1_month',
//             price: '',
//             resolution: '',
//             description: '',
//             status: 'active'
//         });
//         setEditingPromotion(null);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // Validation
//         if (!formData.category) {
//             alert('Please select a category');
//             return;
//         }
//         if (!formData.price || formData.price <= 0) {
//             alert('Please enter a valid price');
//             return;
//         }
//         if (!formData.resolution) {
//             alert('Please select a resolution');
//             return;
//         }

//         setIsSubmitting(true);

//         try {
//             if (editingPromotion) {
//                 // Update existing promotion
//                 const updated = promotions.map(p =>
//                     p.id === editingPromotion.id
//                         ? { ...p, ...formData }
//                         : p
//                 );
//                 setPromotions(updated);
//                 // await updateFixedPromotionAPI(editingPromotion.id, formData);
//             } else {
//                 // Create new promotion
//                 const newPromotion = {
//                     id: Date.now(),
//                     ...formData,
//                     createdAt: new Date().toISOString().split('T')[0]
//                 };
//                 setPromotions([...promotions, newPromotion]);
//                 // await createFixedPromotionAPI(formData);
//             }

//             resetForm();
//             setShowModal(false);
//             alert(editingPromotion ? 'Promotion updated successfully!' : 'Promotion created successfully!');
//         } catch (err) {
//             console.error("❌ Error saving promotion:", err);
//             alert('Failed to save promotion. Please try again.');
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const handleEdit = (promotion) => {
//         setEditingPromotion(promotion);
//         setFormData({
//             category: promotion.category,
//             mediaType: promotion.mediaType,
//             duration: promotion.duration,
//             price: promotion.price,
//             resolution: promotion.resolution,
//             description: promotion.description || '',
//             status: promotion.status
//         });
//         setShowModal(true);
//     };

//     const handleDelete = async (id) => {
//         if (!window.confirm('Are you sure you want to delete this promotion?')) return;

//         try {
//             setPromotions(promotions.filter(p => p.id !== id));
//             // await deleteFixedPromotionAPI(id);
//             alert('Promotion deleted successfully!');
//         } catch (err) {
//             console.error("❌ Error deleting promotion:", err);
//             alert('Failed to delete promotion.');
//         }
//     };

//     const handleToggleStatus = async (id) => {
//         try {
//             const updated = promotions.map(p =>
//                 p.id === id
//                     ? { ...p, status: p.status === 'active' ? 'inactive' : 'active' }
//                     : p
//             );
//             setPromotions(updated);
//             // await togglePromotionStatusAPI(id);
//         } catch (err) {
//             console.error("❌ Error toggling status:", err);
//             alert('Failed to update status.');
//         }
//     };

//     // ─── Get Category Icon ────────────────────────────────────────
//     const getCategoryIcon = (category) => {
//         const found = categoryOptions.find(c => c.value === category);
//         return found ? found.icon : '📌';
//     };

//     const getCategoryLabel = (category) => {
//         const found = categoryOptions.find(c => c.value === category);
//         return found ? found.label : category;
//     };

//     const getMediaTypeLabel = (type) => {
//         const found = mediaTypeOptions.find(m => m.value === type);
//         return found ? found.label : type;
//     };

//     const getDurationLabel = (duration) => {
//         const found = durationOptions.find(d => d.value === duration);
//         return found ? found.label : duration;
//     };

//     const getResolutionLabel = (resolution) => {
//         const found = resolutionOptions.find(r => r.value === resolution);
//         return found ? found.label : resolution;
//     };

//     const getStatusBadge = (status) => {
//         if (status === 'active') {
//             return <span style={activeBadgeStyle}>● Active</span>;
//         }
//         return <span style={inactiveBadgeStyle}>○ Inactive</span>;
//     };

//     // ─── Render ──────────────────────────────────────────────────
//     if (loading) {
//         return (
//             <div style={loadingContainerStyle}>
//                 <FaSpinner style={{ animation: 'spin 1s linear infinite', fontSize: 24, color: '#e66d33' }} />
//                 <p style={{ color: '#888', marginTop: 12 }}>Loading promotions...</p>
//             </div>
//         );
//     }

//     return (
//         <div style={containerStyle}>
//             {/* Header */}
//             <div style={headerSectionStyle}>
//                 <div style={headerLeftStyle}>

//                     <div>
//                         <h3 style={headerTitleStyle}>Fixed Promotions</h3>
//                         <p style={headerSubStyle}>Manage your fixed price promotions</p>
//                     </div>
//                 </div>
//                 <button
//                     onClick={() => { resetForm(); setShowModal(true); }}
//                     style={createButtonStyle}
//                 >
//                     <FaPlus size={14} />
//                     Create Promotion
//                 </button>
//             </div>

//             <div style={tableCardStyle}>
//                 {promotions.length === 0 ? (
//                     <div style={emptyStateStyle}>
//                         <FaTag size={48} color="#ddd" />
//                         <p>No promotions created yet</p>
//                         <button
//                             onClick={() => { resetForm(); setShowModal(true); }}
//                             style={emptyStateButtonStyle}
//                         >
//                             Create Your First Promotion
//                         </button>
//                     </div>
//                 ) : (
//                     <div style={tableWrapperStyle}>
//                         <table style={tableStyle}>
//                             <thead>
//                                 <tr>
//                                     <th style={{ width: '4%', minWidth: '40px', textAlign:"center" }}>#</th>
//                                     <th style={{ width: '16%', minWidth: '120px', textAlign:"center" }}>Category</th>
//                                     <th style={{ width: '10%', minWidth: '90px' , textAlign:"center"}}>Media Type</th>
//                                     <th style={{ width: '10%', minWidth: '90px' , textAlign:"center"}}>Duration</th>
//                                     <th style={{ width: '8%', minWidth: '80px' , textAlign:"center"}}>Price (₹)</th>
//                                     <th style={{ width: '12%', minWidth: '100px', textAlign:"center" }}>Resolution</th>
//                                     <th style={{ width: '8%', minWidth: '70px', textAlign:"center" }}>Status</th>
//                                     <th style={{ width: '8%', minWidth: '70px' , textAlign:"center"}}>Loops</th>
//                                     <th style={{ width: '8%', minWidth: '70px', textAlign:"center" }}>Seconds</th>
//                                     <th style={{ width: '10%', minWidth: '90px', textAlign:"center" }}>Created</th>
//                                     <th style={{ width: '10%', minWidth: '90px' , textAlign:"center"}}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {promotions.map((promo, index) => (
//                                     <tr
//                                         key={promo.id}
//                                         style={{
//                                             ...tableRowStyle,
//                                             background: hoveredRow === promo.id ? '#fef9f4' : (index % 2 === 0 ? '#ffffff' : '#fcf9f7')
//                                         }}
//                                         onMouseEnter={() => setHoveredRow(promo.id)}
//                                         onMouseLeave={() => setHoveredRow(null)}
//                                     >
//                                         <td style={tableCellStyle}>{index + 1}</td>
//                                         <td style={tableCellStyle}>
//                                             <span style={categoryBadgeStyle}>
//                                                 {getCategoryIcon(promo.category)} {getCategoryLabel(promo.category)}
//                                             </span>
//                                         </td>
//                                         <td style={tableCellStyle}>{getMediaTypeLabel(promo.mediaType)}</td>
//                                         <td style={tableCellStyle}>{getDurationLabel(promo.duration)}</td>
//                                         <td style={{ ...tableCellStyle, fontWeight: 700, color: '#e66d33' }}>
//                                             ₹{promo.price}
//                                         </td>
//                                         <td style={tableCellStyle}>{getResolutionLabel(promo.resolution)}</td>
//                                         <td style={tableCellStyle}>
//                                             <button
//                                                 onClick={() => handleToggleStatus(promo.id)}
//                                                 style={statusToggleStyle}
//                                             >
//                                                 {getStatusBadge(promo.status)}
//                                             </button>
//                                         </td>
//                                         <td style={tableCellStyle}>
//                                             <span style={loopBadgeStyle}>
//                                                 {promo.noOfLoops || '-'}
//                                             </span>
//                                         </td>
//                                         <td style={tableCellStyle}>
//                                             <span style={secondsBadgeStyle}>
//                                                 {promo.secondsPerAdd || '-'}s
//                                             </span>
//                                         </td>
//                                         <td style={{ ...tableCellStyle, fontSize: '12px', color: '#888' }}>
//                                             {promo.createdAt || '-'}
//                                         </td>
//                                         <td style={tableCellStyle}>
//                                             <div style={actionGroupStyle}>
//                                                 <button
//                                                     onClick={() => handleEdit(promo)}
//                                                     style={editActionStyle}
//                                                     title="Edit"
//                                                 >
//                                                     <FaEdit size={14} />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => handleDelete(promo.id)}
//                                                     style={deleteActionStyle}
//                                                     title="Delete"
//                                                 >
//                                                     <FaTrash size={14} />
//                                                 </button>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>

//             {/* Modal */}
//             <AnimatePresence>
//                 {showModal && (
//                     <motion.div
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         exit={{ opacity: 0 }}
//                         style={modalOverlayStyle}
//                         onClick={() => !isSubmitting && setShowModal(false)}
//                     >
//                         <motion.div
//                             initial={{ scale: 0.9, y: 20 }}
//                             animate={{ scale: 1, y: 0 }}
//                             exit={{ scale: 0.9, y: 20 }}
//                             style={modalStyle}
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             {/* Modal Header */}
//                             <div style={modalHeaderStyle}>
//                                 <h3 style={modalTitleStyle}>
//                                     {editingPromotion ? 'Edit Promotion' : 'Create New Promotion'}
//                                 </h3>
//                                 <button
//                                     onClick={() => setShowModal(false)}
//                                     style={modalCloseStyle}
//                                     disabled={isSubmitting}
//                                 >
//                                     <FaTimes />
//                                 </button>
//                             </div>

//                             {/* Modal Body - Form */}
//                             <form onSubmit={handleSubmit} style={modalBodyStyle}>
//                                 {/* Category */}
//                                 <div style={formGroupStyle}>
//                                     <label style={formLabelStyle}>Category *</label>
//                                     <select
//                                         name="category"
//                                         value={formData.category}
//                                         onChange={handleInputChange}
//                                         style={selectStyle}
//                                         required
//                                     >
//                                         <option value="">Select Category</option>
//                                         {categoryOptions.map(opt => (
//                                             <option key={opt.value} value={opt.value}>
//                                                 {opt.icon} {opt.label}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div style={formRowStyle}>
//                                     {/* Media Type */}
//                                     <div style={{ ...formGroupStyle, flex: 1 }}>
//                                         <label style={formLabelStyle}>Media Type</label>
//                                         <select
//                                             name="mediaType"
//                                             value={formData.mediaType}
//                                             onChange={handleInputChange}
//                                             style={selectStyle}
//                                         >
//                                             {mediaTypeOptions.map(opt => (
//                                                 <option key={opt.value} value={opt.value}>
//                                                     {opt.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     {/* Duration */}
//                                     <div style={{ ...formGroupStyle, flex: 1 }}>
//                                         <label style={formLabelStyle}>Duration *</label>
//                                         <select
//                                             name="duration"
//                                             value={formData.duration}
//                                             onChange={handleInputChange}
//                                             style={selectStyle}
//                                             required
//                                         >
//                                             {durationOptions.map(opt => (
//                                                 <option key={opt.value} value={opt.value}>
//                                                     {opt.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div style={formRowStyle}>
//                                     {/* Price */}
//                                     <div style={{ ...formGroupStyle, flex: 1 }}>
//                                         <label style={formLabelStyle}>Price (₹) *</label>
//                                         <input
//                                             type="number"
//                                             name="price"
//                                             value={formData.price}
//                                             onChange={handleInputChange}
//                                             style={inputStyle}
//                                             placeholder="Enter price"
//                                             min="0"
//                                             step="1"
//                                             required
//                                         />
//                                     </div>

//                                     {/* Resolution */}
//                                     <div style={{ ...formGroupStyle, flex: 1 }}>
//                                         <label style={formLabelStyle}>Resolution *</label>
//                                         <select
//                                             name="resolution"
//                                             value={formData.resolution}
//                                             onChange={handleInputChange}
//                                             style={selectStyle}
//                                             required
//                                         >
//                                             <option value="">Select Resolution</option>
//                                             {resolutionOptions.map(opt => (
//                                                 <option key={opt.value} value={opt.value}>
//                                                     {opt.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Add this after the Resolution field */}
//                                 <div style={formRowStyle}>
//                                     {/* No of Loops */}
//                                     <div style={{ ...formGroupStyle, flex: 1 }}>
//                                         <label style={formLabelStyle}>No of Loops</label>
//                                         <select
//                                             name="noOfLoops"
//                                             value={formData.noOfLoops}
//                                             onChange={handleInputChange}
//                                             style={selectStyle}
//                                         >
//                                             {loopOptions.map(opt => (
//                                                 <option key={opt.value} value={opt.value}>
//                                                     {opt.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     {/* Seconds Per Add */}
//                                     <div style={{ ...formGroupStyle, flex: 1 }}>
//                                         <label style={formLabelStyle}>Seconds Per Add</label>
//                                         <select
//                                             name="secondsPerAdd"
//                                             value={formData.secondsPerAdd}
//                                             onChange={handleInputChange}
//                                             style={selectStyle}
//                                         >
//                                             {secondsOptions.map(opt => (
//                                                 <option key={opt.value} value={opt.value}>
//                                                     {opt.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Description */}
//                                 <div style={formGroupStyle}>
//                                     <label style={formLabelStyle}>Description</label>
//                                     <textarea
//                                         name="description"
//                                         value={formData.description}
//                                         onChange={handleInputChange}
//                                         style={textareaStyle}
//                                         placeholder="Enter description (optional)"
//                                         rows="2"
//                                     />
//                                 </div>

//                                 {/* Form Actions */}
//                                 <div style={formActionStyle}>
//                                     <button
//                                         type="button"
//                                         onClick={() => setShowModal(false)}
//                                         style={cancelButtonStyle}
//                                         disabled={isSubmitting}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button
//                                         type="submit"
//                                         style={submitButtonStyle}
//                                         disabled={isSubmitting}
//                                     >
//                                         {isSubmitting ? (
//                                             <>
//                                                 <FaSpinner style={{ animation: 'spin 1s linear infinite' }} />
//                                                 {editingPromotion ? 'Updating...' : 'Creating...'}
//                                             </>
//                                         ) : (
//                                             <>
//                                                 {editingPromotion ? 'Update' : 'Create'}
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </form>
//                         </motion.div>
//                     </motion.div>
//                 )}
//             </AnimatePresence>

//             <style>{`
//                 @keyframes spin { to { transform: rotate(360deg); } }
//                 ::-webkit-scrollbar { width: 6px; height: 6px; }
//                 ::-webkit-scrollbar-track { background: #f5f0eb; border-radius: 10px; }
//                 ::-webkit-scrollbar-thumb { background: #e66d33; border-radius: 10px; }
//                 ::-webkit-scrollbar-thumb:hover { background: #d35400; }
//             `}</style>
//         </div>
//     );
// };

// // ─── Styles ──────────────────────────────────────────────────────

// const containerStyle = {
//     padding: "10px",
// };

// const loadingContainerStyle = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "10px",
//     minHeight: "200px",
// };

// const headerSectionStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: 20,
//     flexWrap: "wrap",
//     gap: 12,
// };

// const headerLeftStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: 12,
// };

// const headerIconWrapper = {
//     width: 40,
//     height: 40,
//     borderRadius: 10,
//     background: "rgba(230, 126, 34, 0.12)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
// };

// const headerTitleStyle = {
//     margin: 0,
//     fontSize: "18px",
//     fontWeight: 700,
//     color: "#333",
// };

// const headerSubStyle = {
//     margin: 0,
//     fontSize: "13px",
//     color: "#888",
// };

// const createButtonStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     padding: "10px 20px",
//     background: "#e66d33",
//     color: "#fff",
//     border: "none",
//     borderRadius: 10,
//     fontWeight: 600,
//     fontSize: "14px",
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//     boxShadow: "0 4px 15px rgba(230, 126, 34, 0.3)",
// };

// const tableCardStyle = {
//     background: "#ffffff",
//     borderRadius: 16,
//     boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
//     overflow: "hidden",
//     border: "1px solid #f0ebe6",
//     padding: "10px",
// };

// const tableWrapperStyle = {
//     overflowX: "auto",
// };

// const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     minWidth: "900px",
// };

// const tableRowStyle = {
//     borderBottom: "1px solid #f0ebe6",
//     transition: "background 0.2s ease",
// };

// const tableCellStyle = {
//     padding: "12px 14px",
//     fontSize: "13px",
//     color: "#333",
//     textAlign: "center",
// };

// const categoryBadgeStyle = {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 6,
//     padding: "4px 12px",
//     background: "rgba(230, 126, 34, 0.08)",
//     borderRadius: 20,
//     fontSize: "12px",
//     fontWeight: 500,
//     color: "#e66d33",
// };

// const activeBadgeStyle = {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 4,
//     padding: "2px 10px",
//     background: "#d4edda",
//     borderRadius: 12,
//     fontSize: "11px",
//     fontWeight: 600,
//     color: "#155724",
//     cursor: "pointer",
// };

// const inactiveBadgeStyle = {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 4,
//     padding: "2px 10px",
//     background: "#f8d7da",
//     borderRadius: 12,
//     fontSize: "11px",
//     fontWeight: 600,
//     color: "#721c24",
//     cursor: "pointer",
// };

// const statusToggleStyle = {
//     background: "none",
//     border: "none",
//     cursor: "pointer",
//     padding: 0,
// };

// const actionGroupStyle = {
//     display: "flex",
//     gap: 8,
// };

// const editActionStyle = {
//     padding: "6px 10px",
//     background: "rgba(230, 126, 34, 0.1)",
//     color: "#e66d33",
//     border: "none",
//     borderRadius: 6,
//     cursor: "pointer",
//     transition: "all 0.2s ease",
// };

// const deleteActionStyle = {
//     padding: "6px 10px",
//     background: "rgba(220, 53, 69, 0.1)",
//     color: "#dc3545",
//     border: "none",
//     borderRadius: 6,
//     cursor: "pointer",
//     transition: "all 0.2s ease",
// };

// // ─── Modal Styles ──────────────────────────────────────────────

// const modalOverlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: "rgba(0,0,0,0.5)",
//     backdropFilter: "blur(4px)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9999,
//     padding: "20px",
// };

// const modalStyle = {
//     background: "#ffffff",
//     borderRadius: 16,
//     width: "100%",
//     maxWidth: "580px",
//     maxHeight: "90vh",
//     overflow: "auto",
//     boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
// };

// const modalHeaderStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "20px 24px",
//     borderBottom: "1px solid #f0ebe6",
// };

// const modalTitleStyle = {
//     margin: 0,
//     fontSize: "18px",
//     fontWeight: 700,
//     color: "#333",
// };

// const modalCloseStyle = {
//     background: "none",
//     border: "none",
//     fontSize: "20px",
//     cursor: "pointer",
//     color: "#999",
//     padding: "4px 8px",
//     transition: "color 0.2s ease",
// };

// const modalBodyStyle = {
//     padding: "24px",
// };

// const formRowStyle = {
//     display: "flex",
//     gap: "16px",
// };

// const formGroupStyle = {
//     marginBottom: "16px",
// };

// const formLabelStyle = {
//     display: "block",
//     fontSize: "13px",
//     fontWeight: 600,
//     color: "#555",
//     marginBottom: "6px",
// };

// const inputStyle = {
//     width: "100%",
//     padding: "10px 12px",
//     border: "1px solid #e0d6ce",
//     borderRadius: 8,
//     fontSize: "14px",
//     outline: "none",
//     transition: "border-color 0.2s ease",
//     boxSizing: "border-box",
// };

// const selectStyle = {
//     ...inputStyle,
//     appearance: "auto",
//     background: "#fff",
// };

// const textareaStyle = {
//     ...inputStyle,
//     resize: "vertical",
//     fontFamily: "inherit",
// };

// const formActionStyle = {
//     display: "flex",
//     gap: "12px",
//     justifyContent: "flex-end",
//     marginTop: "8px",
//     paddingTop: "16px",
//     borderTop: "1px solid #f0ebe6",
// };

// const cancelButtonStyle = {
//     padding: "10px 24px",
//     background: "#f0f0f0",
//     color: "#666",
//     border: "none",
//     borderRadius: 8,
//     fontSize: "14px",
//     fontWeight: 500,
//     cursor: "pointer",
//     transition: "all 0.2s ease",
// };

// const submitButtonStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     padding: "10px 24px",
//     background: "#e66d33",
//     color: "#fff",
//     border: "none",
//     borderRadius: 8,
//     fontSize: "14px",
//     fontWeight: 600,
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//     boxShadow: "0 4px 15px rgba(230, 126, 34, 0.3)",
// };

// // ─── Empty State Styles ─────────────────────────────────────────

// const emptyStateStyle = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "60px 20px",
//     gap: "12px",
//     color: "#999",
// };

// const emptyStateButtonStyle = {
//     padding: "10px 24px",
//     background: "#e66d33",
//     color: "#fff",
//     border: "none",
//     borderRadius: 8,
//     fontSize: "14px",
//     fontWeight: 500,
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//     marginTop: "8px",
// };
// // Add these with your other style objects
// const loopBadgeStyle = {
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "2px 10px",
//     background: "rgba(52, 152, 219, 0.1)",
//     borderRadius: 12,
//     fontSize: "12px",
//     fontWeight: 600,
//     color: "#2980b9",
// };

// const secondsBadgeStyle = {
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "2px 10px",
//     background: "rgba(46, 204, 113, 0.1)",
//     borderRadius: 12,
//     fontSize: "12px",
//     fontWeight: 600,
//     color: "#27ae60",
// };


// export default FixedPromotionBilling;




// FixedPromotionBilling.jsx
import React, { useState, useEffect } from "react";
import {
    FaEdit, FaSave, FaSpinner, FaCheckCircle, FaTag, FaMoneyBillWave,
    FaClock, FaUser, FaMobileAlt, FaPlus, FaTrash, FaEye, FaTimes,
    FaImage, FaVideo, FaCalendarAlt, FaDollarSign, FaCog, FaList,
    FaStar, FaTrashAlt
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

// ─── API Service ──────────────────────────────────────────────────
const API_BASE_URL = "https://backend.maamaas.com/promotions/api/subscription/plans";

// API Helper Functions
const getAuthToken = () => {
    // Replace with your actual token retrieval logic
    return localStorage.getItem('authToken') || '';
};

const apiRequest = async (url, method = 'GET', body = null) => {
    const options = {
        method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getAuthToken()}`
        }
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(url, options);

        // Handle non-OK responses
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        // For DELETE requests or responses with no content
        if (method === 'DELETE' || response.status === 204) {
            return null; // No content to parse
        }

        // For other methods, try to parse JSON
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return await response.json();
        }

        // Return empty object if no JSON
        return {};

    } catch (error) {
        console.error('API Request Error:', error);
        throw error;
    }
};

// ─── Fixed Promotion Billing Component ──────────────────────────
const FixedPromotionBilling = () => {
    const [promotions, setPromotions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingPromotion, setEditingPromotion] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hoveredRow, setHoveredRow] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [promotionToDelete, setPromotionToDelete] = useState(null);

    // ─── Form State ──────────────────────────────────────────────
    const [formData, setFormData] = useState({
        subscriptionType: 'CAMPAIGN',
        planType: 'BANNER_AD',
        planName: '',
        description: '',
        mostPopular: false,
        prices: [
            {
                mediaType: 'IMAGE',
                billingType: 'DAY',
                validityDays: 30,
                originalPrice: 0,
                sellingPrice: 0
            }
        ],
        features: [
            {
                feature: '',
                displayOrder: 0
            }
        ]
    });

    // ─── Options (Enums from API) ──────────────────────────────────
    const subscriptionTypeOptions = [
        { value: 'CAMPAIGN', label: 'Campaign' },
        { value: 'DIGITAL_SCREEN', label: 'Digital Screen' }
    ];

    const planTypeOptions = [
        { value: 'MENU_DISCOUNT', label: 'Menu Discount' },
        { value: 'COUPON', label: 'Coupon' },
        { value: 'BUY_ONE_GET_ONE', label: 'Buy One Get One' },
        { value: 'COMBO_DISCOUNT', label: 'Combo Discount' },
        { value: 'LEADS', label: 'Leads' },
        { value: 'BANNER_AD', label: 'Banner Ad' },
        { value: 'VIDEO_AD', label: 'Video Ad' },
        { value: 'FEATURED_VENDOR', label: 'Featured Vendor' },
        { value: 'DIGITAL_SCREEN', label: 'Digital Screen' },
        { value: 'PUSH_NOTIFICATION', label: 'Push Notification' },
        { value: 'SMS_MARKETING', label: 'SMS Marketing' },
        { value: 'EMAIL_MARKETING', label: 'Email Marketing' },
        { value: 'SOCIAL_MEDIA_PROMOTION', label: 'Social Media Promotion' }
    ];

    const mediaTypeOptions = [
        { value: 'IMAGE', label: 'Image' },
        { value: 'VIDEO', label: 'Video' },
        { value: 'BOTH', label: 'Both' }
    ];

    const billingTypeOptions = [
        { value: 'DAY', label: 'Day' },
        { value: 'MONTH', label: 'Month' },
        { value: 'YEAR', label: 'Year' }
    ];

    // ─── Fetch Data ──────────────────────────────────────────────
    useEffect(() => {
        fetchPromotions();
    }, []);

    const fetchPromotions = async () => {
        try {
            setLoading(true);
            const data = await apiRequest(API_BASE_URL, 'GET');
            setPromotions(data || []);
        } catch (err) {
            console.error("❌ Error fetching promotions:", err);
            alert('Failed to load promotions. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const fetchPromotionById = async (id) => {
        try {
            const data = await apiRequest(`${API_BASE_URL}/${id}`, 'GET');
            return data;
        } catch (err) {
            console.error("❌ Error fetching promotion:", err);
            throw err;
        }
    };

    // ─── Form Handlers ────────────────────────────────────────────
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handlePriceChange = (index, field, value) => {
        const updatedPrices = [...formData.prices];
        updatedPrices[index] = { ...updatedPrices[index], [field]: value };
        setFormData(prev => ({ ...prev, prices: updatedPrices }));
    };

    const handleFeatureChange = (index, field, value) => {
        const updatedFeatures = [...formData.features];
        updatedFeatures[index] = { ...updatedFeatures[index], [field]: value };
        setFormData(prev => ({ ...prev, features: updatedFeatures }));
    };

    const addPrice = () => {
        setFormData(prev => ({
            ...prev,
            prices: [
                ...prev.prices,
                {
                    mediaType: 'IMAGE',
                    billingType: 'DAY',
                    validityDays: 30,
                    originalPrice: 0,
                    sellingPrice: 0
                }
            ]
        }));
    };

    const removePrice = (index) => {
        if (formData.prices.length <= 1) {
            alert('At least one price is required');
            return;
        }
        setFormData(prev => ({
            ...prev,
            prices: prev.prices.filter((_, i) => i !== index)
        }));
    };

    const addFeature = () => {
        setFormData(prev => ({
            ...prev,
            features: [
                ...prev.features,
                { feature: '', displayOrder: prev.features.length }
            ]
        }));
    };

    const removeFeature = (index) => {
        if (formData.features.length <= 1) {
            alert('At least one feature is required');
            return;
        }
        setFormData(prev => ({
            ...prev,
            features: prev.features.filter((_, i) => i !== index)
        }));
    };

    const resetForm = () => {
        setFormData({
            subscriptionType: 'CAMPAIGN',
            planType: 'BANNER_AD',
            planName: '',
            description: '',
            mostPopular: false,
            prices: [
                {
                    mediaType: 'IMAGE',
                    billingType: 'DAY',
                    validityDays: 30,
                    originalPrice: 0,
                    sellingPrice: 0
                }
            ],
            features: [
                {
                    feature: '',
                    displayOrder: 0
                }
            ]
        });
        setEditingPromotion(null);
    };

    // ─── CRUD Handlers ────────────────────────────────────────────
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.planName.trim()) {
            alert('Please enter a plan name');
            return;
        }
        if (!formData.subscriptionType) {
            alert('Please select a subscription type');
            return;
        }
        if (!formData.planType) {
            alert('Please select a plan type');
            return;
        }

        // Validate prices
        for (let price of formData.prices) {
            if (!price.sellingPrice || price.sellingPrice <= 0) {
                alert('Please enter valid selling price for all price entries');
                return;
            }
            if (!price.validityDays || price.validityDays <= 0) {
                alert('Please enter valid validity days for all price entries');
                return;
            }
        }

        setIsSubmitting(true);

        try {
            // Prepare payload - remove empty features
            const payload = {
                ...formData,
                features: formData.features.filter(f => f.feature.trim() !== '')
            };

            if (editingPromotion) {
                // Update existing promotion
                await apiRequest(`${API_BASE_URL}/${editingPromotion.id}`, 'PUT', payload);
                alert('Promotion updated successfully!');
            } else {
                // Create new promotion
                await apiRequest(API_BASE_URL, 'POST', payload);
                alert('Promotion created successfully!');
            }

            resetForm();
            setShowModal(false);
            fetchPromotions(); // Refresh list
        } catch (err) {
            console.error("❌ Error saving promotion:", err);
            alert(err.message || 'Failed to save promotion. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEdit = async (promotion) => {
        try {
            setLoading(true);
            // Fetch full details by ID
            const data = await fetchPromotionById(promotion.id);

            setEditingPromotion(data);
            setFormData({
                subscriptionType: data.subscriptionType || 'CAMPAIGN',
                planType: data.planType || 'BANNER_AD',
                planName: data.planName || '',
                description: data.description || '',
                mostPopular: data.mostPopular || false,
                prices: data.prices || [
                    {
                        mediaType: 'IMAGE',
                        billingType: 'DAY',
                        validityDays: 30,
                        originalPrice: 0,
                        sellingPrice: 0
                    }
                ],
                features: data.features || [
                    {
                        feature: '',
                        displayOrder: 0
                    }
                ]
            });
            setShowModal(true);
        } catch (err) {
            console.error("❌ Error fetching promotion details:", err);
            alert('Failed to load promotion details. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            await apiRequest(`${API_BASE_URL}/${id}`, 'DELETE');
            alert('Promotion deleted successfully!');
            setShowDeleteConfirm(false);
            setPromotionToDelete(null);
            fetchPromotions(); // Refresh list
        } catch (err) {
            console.error("❌ Error deleting promotion:", err);
            alert(err.message || 'Failed to delete promotion.');
        }
    };

    const confirmDelete = (promotion) => {
        setPromotionToDelete(promotion);
        setShowDeleteConfirm(true);
    };

    // ─── Helper Functions ─────────────────────────────────────────
    const getSubscriptionTypeLabel = (type) => {
        const found = subscriptionTypeOptions.find(s => s.value === type);
        return found ? found.label : type;
    };

    const getPlanTypeLabel = (type) => {
        const found = planTypeOptions.find(p => p.value === type);
        return found ? found.label : type;
    };

    const getMediaTypeLabel = (type) => {
        const found = mediaTypeOptions.find(m => m.value === type);
        return found ? found.label : type;
    };

    const getBillingTypeLabel = (type) => {
        const found = billingTypeOptions.find(b => b.value === type);
        return found ? found.label : type;
    };

    const getStatusBadge = (status) => {
        if (status === 'ACTIVE') {
            return <span style={activeBadgeStyle}>● Active</span>;
        }
        return <span style={inactiveBadgeStyle}>○ Inactive</span>;
    };

    const getPlanTypeIcon = (type) => {
        const icons = {
            'MENU_DISCOUNT': '📋',
            'COUPON': '🎫',
            'BUY_ONE_GET_ONE': '🎁',
            'COMBO_DISCOUNT': '💰',
            'LEADS': '👤',
            'BANNER_AD': '🖼️',
            'VIDEO_AD': '🎬',
            'FEATURED_VENDOR': '⭐',
            'DIGITAL_SCREEN': '📺',
            'PUSH_NOTIFICATION': '🔔',
            'SMS_MARKETING': '📱',
            'EMAIL_MARKETING': '✉️',
            'SOCIAL_MEDIA_PROMOTION': '📢'
        };
        return icons[type] || '📌';
    };

    // ─── Render ──────────────────────────────────────────────────
    if (loading) {
        return (
            <div style={loadingContainerStyle}>
                <FaSpinner style={{ animation: 'spin 1s linear infinite', fontSize: 24, color: '#e66d33' }} />
                <p style={{ color: '#888', marginTop: 12 }}>Loading promotions...</p>
            </div>
        );
    }

    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerSectionStyle}>
                <div style={headerLeftStyle}>
                    <div style={headerIconWrapper}>
                        <FaTag size={20} color="#e66d33" />
                    </div>
                    <div>
                        <h3 style={headerTitleStyle}>Fixed Promotions</h3>
                        <p style={headerSubStyle}>Manage your subscription plans and promotions</p>
                    </div>
                </div>
                <button
                    onClick={() => { resetForm(); setShowModal(true); }}
                    style={createButtonStyle}
                >
                    <FaPlus size={14} />
                    Create Promotion
                </button>
            </div>

            <div style={tableCardStyle}>
                {promotions.length === 0 ? (
                    <div style={emptyStateStyle}>
                        <FaTag size={48} color="#ddd" />
                        <p>No promotions created yet</p>
                        <button
                            onClick={() => { resetForm(); setShowModal(true); }}
                            style={emptyStateButtonStyle}
                        >
                            Create Your First Promotion
                        </button>
                    </div>
                ) : (
                    <div style={tableWrapperStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{ width: '4%', minWidth: '40px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>#</th>
                                    <th style={{ width: '12%', minWidth: '100px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Plan Name</th>
                                    <th style={{ width: '10%', minWidth: '90px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Type</th>
                                    <th style={{ width: '12%', minWidth: '100px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Plan Type</th>
                                    <th style={{ width: '10%', minWidth: '80px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Price</th>
                                    <th style={{ width: '8%', minWidth: '70px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Popular</th>
                                    <th style={{ width: '8%', minWidth: '70px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Status</th>
                                    <th style={{ width: '12%', minWidth: '100px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Media</th>
                                    <th style={{ width: '10%', minWidth: '80px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Validity</th>
                                    <th style={{ width: '10%', minWidth: '90px', textAlign: "center", backgroundColor: "#e66d33", color: "white", padding: "10px" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {promotions.map((promo, index) => {
                                    const firstPrice = promo.prices && promo.prices.length > 0 ? promo.prices[0] : null;
                                    const mediaTypes = promo.prices ? promo.prices.map(p => p.mediaType).join(', ') : '-';
                                    const validityDays = firstPrice ? firstPrice.validityDays : '-';

                                    return (
                                        <tr
                                            key={promo.id || index}
                                            style={{
                                                ...tableRowStyle,
                                                background: hoveredRow === promo.id ? '#fef9f4' : (index % 2 === 0 ? '#ffffff' : '#fcf9f7')
                                            }}
                                            onMouseEnter={() => setHoveredRow(promo.id)}
                                            onMouseLeave={() => setHoveredRow(null)}
                                        >
                                            <td style={tableCellStyle}>{index + 1}</td>
                                            <td style={{ ...tableCellStyle, fontWeight: 600, color: '#333' }}>
                                                {promo.planName || '-'}
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={subscriptionBadgeStyle}>
                                                    {getSubscriptionTypeLabel(promo.subscriptionType)}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={planTypeBadgeStyle}>
                                                    {getPlanTypeIcon(promo.planType)} {getPlanTypeLabel(promo.planType)}
                                                </span>
                                            </td>
                                            <td style={{ ...tableCellStyle, fontWeight: 700, color: '#e66d33' }}>
                                                ₹{firstPrice ? firstPrice.sellingPrice : '0'}
                                            </td>
                                            <td style={tableCellStyle}>
                                                {promo.mostPopular ? (
                                                    <span style={popularBadgeStyle}>
                                                        <FaStar size={12} /> Popular
                                                    </span>
                                                ) : (
                                                    <span style={{ color: '#ccc' }}>—</span>
                                                )}
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={statusBadgeStyle(promo.status)}>
                                                    {promo.status === 'ACTIVE' ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={mediaBadgeStyle}>
                                                    {mediaTypes}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={validityBadgeStyle}>
                                                    {validityDays}d
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <div style={actionGroupStyle}>
                                                    <button
                                                        onClick={() => handleEdit(promo)}
                                                        style={editActionStyle}
                                                        title="Edit"
                                                    >
                                                        <FaEdit size={14} />
                                                    </button>
                                                    <button
                                                        onClick={() => confirmDelete(promo)}
                                                        style={deleteActionStyle}
                                                        title="Delete"
                                                    >
                                                        <FaTrash size={14} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Create/Edit Modal */}
            <AnimatePresence>
                {showModal && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        style={modalOverlayStyle}
                        onClick={() => !isSubmitting && setShowModal(false)}
                    >
                        <motion.div
                            initial={{ scale: 0.9, y: 20 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.9, y: 20 }}
                            style={modalStyle}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Modal Header */}
                            <div style={modalHeaderStyle}>
                                <h3 style={modalTitleStyle}>
                                    {editingPromotion ? 'Edit Promotion' : 'Create New Promotion'}
                                </h3>
                                <button
                                    onClick={() => setShowModal(false)}
                                    style={modalCloseStyle}
                                    disabled={isSubmitting}
                                >
                                    <FaTimes />
                                </button>
                            </div>

                            {/* Modal Body - Form */}
                            <form onSubmit={handleSubmit} style={modalBodyStyle}>
                                {/* Subscription Type & Plan Type */}
                                <div style={formRowStyle}>
                                    <div style={{ ...formGroupStyle, flex: 1 }}>
                                        <label style={formLabelStyle}>Subscription Type *</label>
                                        <select
                                            name="subscriptionType"
                                            value={formData.subscriptionType}
                                            onChange={handleInputChange}
                                            style={selectStyle}
                                            required
                                        >
                                            {subscriptionTypeOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div style={{ ...formGroupStyle, flex: 1 }}>
                                        <label style={formLabelStyle}>Plan Type *</label>
                                        <select
                                            name="planType"
                                            value={formData.planType}
                                            onChange={handleInputChange}
                                            style={selectStyle}
                                            required
                                        >
                                            {planTypeOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Plan Name */}
                                <div style={formGroupStyle}>
                                    <label style={formLabelStyle}>Plan Name *</label>
                                    <input
                                        type="text"
                                        name="planName"
                                        value={formData.planName}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        placeholder="Enter plan name"
                                        required
                                    />
                                </div>

                                {/* Description */}
                                <div style={formGroupStyle}>
                                    <label style={formLabelStyle}>Description</label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        style={textareaStyle}
                                        placeholder="Enter description (optional)"
                                        rows="2"
                                    />
                                </div>

                                {/* Most Popular */}
                                <div style={formGroupStyle}>
                                    <label style={formLabelStyle}>
                                        <input
                                            type="checkbox"
                                            name="mostPopular"
                                            checked={formData.mostPopular}
                                            onChange={handleInputChange}
                                            style={{ marginRight: 8 }}
                                        />
                                        Mark as Most Popular
                                    </label>
                                </div>

                                {/* Prices Section */}
                                <div style={sectionHeaderStyle}>
                                    <h4 style={sectionTitleStyle}>Prices</h4>
                                    <button
                                        type="button"
                                        onClick={addPrice}
                                        style={addButtonStyle}
                                    >
                                        <FaPlus size={12} /> Add Price
                                    </button>
                                </div>

                                {formData.prices.map((price, index) => (
                                    <div key={index} style={priceCardStyle}>
                                        <div style={priceHeaderStyle}>
                                            <span style={priceIndexStyle}>Price #{index + 1}</span>
                                            {formData.prices.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removePrice(index)}
                                                    style={removeButtonStyle}
                                                >
                                                    <FaTrashAlt size={12} />
                                                </button>
                                            )}
                                        </div>
                                        <div style={formRowStyle}>
                                            <div style={{ ...formGroupStyle, flex: 1 }}>
                                                <label style={formLabelStyle}>Media Type</label>
                                                <select
                                                    value={price.mediaType}
                                                    onChange={(e) => handlePriceChange(index, 'mediaType', e.target.value)}
                                                    style={selectStyle}
                                                >
                                                    {mediaTypeOptions.map(opt => (
                                                        <option key={opt.value} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div style={{ ...formGroupStyle, flex: 1 }}>
                                                <label style={formLabelStyle}>Billing Type</label>
                                                <select
                                                    value={price.billingType}
                                                    onChange={(e) => handlePriceChange(index, 'billingType', e.target.value)}
                                                    style={selectStyle}
                                                >
                                                    {billingTypeOptions.map(opt => (
                                                        <option key={opt.value} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div style={formRowStyle}>
                                            <div style={{ ...formGroupStyle, flex: 1 }}>
                                                <label style={formLabelStyle}>Validity (Days) *</label>
                                                <input
                                                    type="number"
                                                    value={price.validityDays}
                                                    onChange={(e) => handlePriceChange(index, 'validityDays', parseInt(e.target.value) || 0)}
                                                    style={inputStyle}
                                                    min="1"
                                                    required
                                                />
                                            </div>
                                            <div style={{ ...formGroupStyle, flex: 1 }}>
                                                <label style={formLabelStyle}>Original Price</label>
                                                <input
                                                    type="number"
                                                    value={price.originalPrice}
                                                    onChange={(e) => handlePriceChange(index, 'originalPrice', parseFloat(e.target.value) || 0)}
                                                    style={inputStyle}
                                                    min="0"
                                                    step="1"
                                                />
                                            </div>
                                            <div style={{ ...formGroupStyle, flex: 1 }}>
                                                <label style={formLabelStyle}>Selling Price *</label>
                                                <input
                                                    type="number"
                                                    value={price.sellingPrice}
                                                    onChange={(e) => handlePriceChange(index, 'sellingPrice', parseFloat(e.target.value) || 0)}
                                                    style={inputStyle}
                                                    min="0"
                                                    step="1"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Features Section */}
                                <div style={sectionHeaderStyle}>
                                    <h4 style={sectionTitleStyle}>Features</h4>
                                    <button
                                        type="button"
                                        onClick={addFeature}
                                        style={addButtonStyle}
                                    >
                                        <FaPlus size={12} /> Add Feature
                                    </button>
                                </div>

                                {formData.features.map((feature, index) => (
                                    <div key={index} style={featureRowStyle}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                value={feature.feature}
                                                onChange={(e) => handleFeatureChange(index, 'feature', e.target.value)}
                                                style={inputStyle}
                                                placeholder={`Feature #${index + 1}`}
                                            />
                                        </div>
                                        <input
                                            type="number"
                                            value={feature.displayOrder}
                                            onChange={(e) => handleFeatureChange(index, 'displayOrder', parseInt(e.target.value) || 0)}
                                            style={{ ...inputStyle, width: 80 }}
                                            placeholder="Order"
                                        />
                                        {formData.features.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => removeFeature(index)}
                                                style={removeFeatureButtonStyle}
                                            >
                                                <FaTimes size={14} />
                                            </button>
                                        )}
                                    </div>
                                ))}

                                {/* Form Actions */}
                                <div style={formActionStyle}>
                                    <button
                                        type="button"
                                        onClick={() => setShowModal(false)}
                                        style={cancelButtonStyle}
                                        disabled={isSubmitting}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        style={submitButtonStyle}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <FaSpinner style={{ animation: 'spin 1s linear infinite' }} />
                                                {editingPromotion ? 'Updating...' : 'Creating...'}
                                            </>
                                        ) : (
                                            <>
                                                {editingPromotion ? 'Update' : 'Create'}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Delete Confirmation Modal */}
            <AnimatePresence>
                {showDeleteConfirm && promotionToDelete && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        style={modalOverlayStyle}
                        onClick={() => setShowDeleteConfirm(false)}
                    >
                        <motion.div
                            initial={{ scale: 0.9, y: 20 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.9, y: 20 }}
                            style={{ ...modalStyle, maxWidth: '400px' }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={modalHeaderStyle}>
                                <h3 style={modalTitleStyle}>Confirm Delete</h3>
                                <button
                                    onClick={() => setShowDeleteConfirm(false)}
                                    style={modalCloseStyle}
                                >
                                    <FaTimes />
                                </button>
                            </div>
                            <div style={modalBodyStyle}>
                                <p style={{ marginBottom: 8 }}>
                                    Are you sure you want to delete <strong>"{promotionToDelete.planName}"</strong>?
                                </p>
                                <p style={{ fontSize: 13, color: '#888' }}>
                                    This action cannot be undone.
                                </p>
                            </div>
                            <div style={formActionStyle}>
                                <button
                                    onClick={() => setShowDeleteConfirm(false)}
                                    style={cancelButtonStyle}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => handleDelete(promotionToDelete.id)}
                                    style={deleteConfirmButtonStyle}
                                >
                                    <FaTrash size={14} />
                                    Delete
                                </button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                ::-webkit-scrollbar { width: 6px; height: 6px; }
                ::-webkit-scrollbar-track { background: #f5f0eb; border-radius: 10px; }
                ::-webkit-scrollbar-thumb { background: #e66d33; border-radius: 10px; }
                ::-webkit-scrollbar-thumb:hover { background: #d35400; }
            `}</style>
        </div>
    );
};

// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {
    padding: "10px",
};

const loadingContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    minHeight: "200px",
};

const headerSectionStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    flexWrap: "wrap",
    gap: 12,
};

const headerLeftStyle = {
    display: "flex",
    alignItems: "center",
    gap: 12,
};

const headerIconWrapper = {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: "rgba(230, 126, 34, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const headerTitleStyle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: 700,
    color: "#333",
};

const headerSubStyle = {
    margin: 0,
    fontSize: "13px",
    color: "#888",
};

const createButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 20px",
    background: "#e66d33",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 15px rgba(230, 126, 34, 0.3)",
};

const tableCardStyle = {
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    overflow: "hidden",
    border: "1px solid #f0ebe6",
};

const tableWrapperStyle = {
    overflowX: "auto",
    height: "70vh",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1100px",
};

const tableRowStyle = {
    borderBottom: "1px solid #f0ebe6",
    transition: "background 0.2s ease",
};

const tableCellStyle = {
    padding: "12px 14px",
    fontSize: "13px",
    color: "#333",
    textAlign: "center",
};

// Badge Styles
const subscriptionBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "rgba(52, 152, 219, 0.1)",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#2980b9",
};

const planTypeBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "rgba(155, 89, 182, 0.1)",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#8e44ad",
};

const popularBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "rgba(241, 196, 15, 0.15)",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#f39c12",
};

const statusBadgeStyle = (status) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    background: status === 'ACTIVE' ? '#d4edda' : '#f8d7da',
    color: status === 'ACTIVE' ? '#155724' : '#721c24',
});

const mediaBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "rgba(46, 204, 113, 0.1)",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#27ae60",
};

const validityBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "rgba(230, 126, 34, 0.1)",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#e67e22",
};

const activeBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "#d4edda",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#155724",
    cursor: "pointer",
};

const inactiveBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 10px",
    background: "#f8d7da",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    color: "#721c24",
    cursor: "pointer",
};

// Action Styles
const actionGroupStyle = {
    display: "flex",
    gap: 8,
    justifyContent: "center",
};

const editActionStyle = {
    padding: "6px 10px",
    background: "rgba(230, 126, 34, 0.1)",
    color: "#e66d33",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    transition: "all 0.2s ease",
};

const deleteActionStyle = {
    padding: "6px 10px",
    background: "rgba(220, 53, 69, 0.1)",
    color: "#dc3545",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    transition: "all 0.2s ease",
};

// Modal Styles
const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
};

const modalStyle = {
    background: "#ffffff",
    borderRadius: 16,
    width: "100%",
    maxWidth: "700px",
    maxHeight: "90vh",
    overflow: "auto",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
};

const modalHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 24px",
    borderBottom: "1px solid #f0ebe6",
    position: "sticky",
    top: 0,
    background: "#fff",
    zIndex: 1,
};

const modalTitleStyle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: 700,
    color: "#333",
};

const modalCloseStyle = {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#999",
    padding: "4px 8px",
    transition: "color 0.2s ease",
};

const modalBodyStyle = {
    padding: "24px",
};

// Form Styles
const formRowStyle = {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    flexWrap: "wrap",
};

const formGroupStyle = {
    marginBottom: "16px",
};

const formLabelStyle = {
    display: "block",
    fontSize: "13px",
    fontWeight: 600,
    color: "#555",
    marginBottom: "6px",
};

const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #e0d6ce",
    borderRadius: 8,
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    boxSizing: "border-box",
    background: "#fff",
};

const selectStyle = {
    ...inputStyle,
    appearance: "auto",
};

const textareaStyle = {
    ...inputStyle,
    resize: "vertical",
    fontFamily: "inherit",
};

const sectionHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
    marginBottom: "12px",
    paddingTop: "16px",
    borderTop: "1px solid #f0ebe6",
};

const sectionTitleStyle = {
    margin: 0,
    fontSize: "15px",
    fontWeight: 600,
    color: "#333",
};

const addButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 14px",
    background: "rgba(230, 126, 34, 0.1)",
    color: "#e66d33",
    border: "1px solid #e66d33",
    borderRadius: 6,
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease",
};

// Price Card Styles
const priceCardStyle = {
    background: "#fdfaf8",
    border: "1px solid #f0ebe6",
    borderRadius: 10,
    padding: "16px",
    marginBottom: "12px",
};

const priceHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
};

const priceIndexStyle = {
    fontWeight: 600,
    fontSize: "13px",
    color: "#666",
};

const removeButtonStyle = {
    background: "rgba(220, 53, 69, 0.1)",
    color: "#dc3545",
    border: "none",
    borderRadius: 4,
    padding: "4px 8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
};

// Feature Styles
const featureRowStyle = {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "10px",
};

const removeFeatureButtonStyle = {
    background: "rgba(220, 53, 69, 0.1)",
    color: "#dc3545",
    border: "none",
    borderRadius: 4,
    padding: "4px 8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const formActionStyle = {
    display: "flex",
    gap: "12px",
    justifyContent: "Space-between",
    padding: "10px"

};

const cancelButtonStyle = {
    padding: "10px 24px",
    background: "#f0f0f0",
    color: "#666",
    border: "none",
    borderRadius: 8,
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease",
};

const submitButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 24px",
    background: "#e66d33",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 15px rgba(230, 126, 34, 0.3)",
};

const deleteConfirmButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 24px",
    background: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
};

// Empty State Styles
const emptyStateStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    gap: "12px",
    color: "#999",
};

const emptyStateButtonStyle = {
    padding: "10px 24px",
    background: "#e66d33",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginTop: "8px",
};

export default FixedPromotionBilling;